
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/my-shops",
      function () {
        return require("private-next-pages/admin/my-shops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/my-shops"])
      });
    }
  